import React, { useRef, useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import '../home.css';
import Carousel from '../components/homepage-carousel';
import GetInspiredCarousel from '../components/getinspired-carousel';
import scrolldown from '../img/Arrow Down.png';
import insider1 from '../img/Roys Peak 1.png';
import arrow1 from '../img/Vector 5.png';
import insider2 from '../img/Helicopter 1 1.png';
import arrow2 from '../img/Vector 7.png';
import insider3 from '../img/Screenshot 2023-02-24 at 2.38 1.png';
import arrow3 from '../img/Vector 6.png';
import arrow4 from '../img/Vector 3.png';
import arrow5 from '../img/Vector 4.png';

import insider1Mobile from '../img/Peak Thrills/mobile/Hiking-Trail_2.png';
import insider2Mobile from '../img/Helicopter 1 2.jpg';
import insider3Mobile from '../img/Screenshot 2023-02-24 at 2.38 3.jpg';

const Home = () => {

  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const handleClick = (ref) => (event) => {
    event.preventDefault();
    if (isMounted && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div className="above-home-banner"></div>
      <div className="pb-0 pb-lg-5">
        <Carousel />
      </div>
      <div className="pt-4">
        <p className="full-width violet light text-center desktop">Click to explore</p>
        <p className="full-width violet light text-center mobile">Tap to explore</p>
      </div>
      <div className="pt-5 mt-0 mt-sm-3 scroll-down text-center">
        <a href="#explore" onClick={handleClick(ref1)} className="scroll-down-btn"><img src={scrolldown} alt="scroll-down" /></a>
      </div>
      <div className="insider-wrap py-5 purple-bg">
        <div id="explore" className="anchor" ref={ref1}></div>
        <div data-aos="fade-up">
          <h2 className="text-center pt-5 mt-0 mt-sm-5">Insider's Trip Review</h2>
          <div className="container">
            <div className="row insider-row">
              <div className="col-sm-4 insider-col-1">
                <div className="row">
                  <div className="images col-6 col-sm-12">
                    <img className="thumbnail-img desktop" src={insider1} alt="insider1" />
                    <img className="thumbnail-img mobile" src={insider1Mobile} alt="insider1" />
                    <img className="thumbnail-arrow desktop" data-aos="fade-in" src={arrow1} />
                    <img className="thumbnail-arrow mobile" src={arrow4} />
                  </div>
                  <div className="content col-6 col-sm-12 pe-5 pe-sm-0">
                    <h4 className="desktop" data-aos="fade-in">“Hike up Roy's Peak for astounding views of Lake Wanaka.”</h4>
                    <h4 className="mobile">“Hike up <br />Roy's Peak for astounding views of Lake Wanaka.”</h4>
                    <p className="small-text weight-medium">THE RIDE SIDE</p>
                    <NavLink to='/peak-thrills#review'><button className="mt-2">Read Recommendations</button></NavLink>
                  </div>
                </div>
              </div>
              <div className="col-sm-4 insider-col-2 pe-5">
                <div className="row">
                  <div className="content col-6 col-sm-12 ps-5 ps-sm-0">
                    <h4 className="desktop" data-aos="fade-in">“I was blown away <br />by the stunning views of Aoraki/Mount Cook and the breathtaking glaciers.”</h4>
                    <h4 className="mobile">“I was blown <br />away by the stunning views of Aoraki/Mount Cook and the breathtaking glaciers.”</h4>
                    <p className="small-text weight-medium">NELLIE LIM</p>
                    <NavLink to='/wonders-in-the-wild#review'><button className="mt-2">Read Recommendations</button></NavLink>
                  </div>
                  <div className="images mt-0 mt-sm-5 col-6 col-sm-12">
                    <img className="thumbnail-arrow desktop" data-aos="fade-in" src={arrow2} />
                    <img className="thumbnail-arrow mobile" src={arrow5} />
                    <img className="thumbnail-img desktop" src={insider2} alt="insider1" />
                    <img className="thumbnail-img mobile" src={insider2Mobile} alt="insider1" />
                  </div>
                </div>
              </div>
              <div className="col-sm-4 insider-col-3 ps-5">
                <div className="row">
                  <div className="images col-6 col-sm-12">
                    <img className="thumbnail-img desktop" src={insider3} alt="insider1" />
                    <img className="thumbnail-img mobile" src={insider3Mobile} alt="insider1" />
                    <img className="thumbnail-arrow desktop" data-aos="fade-in" src={arrow3} />
                    <img className="thumbnail-arrow mobile" src={arrow4} />
                  </div>
                  <div className="content mt-5 col-6 col-sm-12 pe-5 pe-sm-0">
                    <h4 className="desktop" data-aos="fade-in">“It was super chill with views of Nelson Bay that are hard to beat.”</h4>
                    <h4 className="mobile">“It was super <br />chill with views of Nelson Bay that are hard to beat.”</h4>
                    <p className="small-text weight-medium">CHRISTABEL CHUA</p>
                    <NavLink to='/chill-out-and-about#review'><button className="mt-2">Read Recommendations</button></NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="py-3 py-sm-5 my-3"></div>
        <div className='position-relative'>
          <div className="scroll-down absolute full-width text-center mt-3 mt-sm-0" data-aos="zoom-out">
            <a href="#inspired" onClick={handleClick(ref2)} className="scroll-down-btn"><img src={scrolldown} /></a>
          </div>
        </div>
      </div>
      <div className="section getinspired-section">
        <div id="inspired" className="anchor" ref={ref2}></div>
        <h2 className="text-center" data-aos="fade-up">Get Inspired</h2>
        <div className="p-left pt-3" data-aos="fade-up"><GetInspiredCarousel /></div>
      </div>
      <div className="py-4"></div>
      <div className="section mobile"></div>
      <div className="services-page">
        <div className="scroll-down text-center absolute full-width">
          <p>Back to the top</p>
          <a href="#top"><img src={scrolldown} alt="scroll-down" /></a>
        </div>
      </div>
    </>
  );
};
export default Home;
